"use strict";

const bcrypt = require("bcryptjs");
const formValidation = require("../components/formValidation");
const { authenticateCustomerEvents } = require("../helpers/gtmHelpers");

/**
 * Processes the number of failed login attempts and triggers a password reset modal if the limit is reached.
 * 
 * @param {number} failedAttempts - The current count of failed login attempts.
 * @returns {number} - The updated count of failed login attempts.
 */
function processFailedAttempts(failedAttempts) {
    failedAttempts++;
    if (failedAttempts === 2) {
        failedAttempts = 0;
        $("#requestPasswordResetModal").modal("show");
    }
    return failedAttempts;
}

/**
 * Completes the migration process by making an AJAX call.
 * 
 * @param {jQuery} form - The jQuery form object containing the login form elements.
 * @param {string} url - The URL to send the AJAX request to.
 * @returns {Promise<Object>} - A promise that resolves to an object containing the error status.
 */
const completeMigration = async (form, url) => {
    try {
        // Extract the CSRF token from the form
        const csrfToken = form.find("input[name='csrf_token']").val();

        // Include the CSRF token in the data sent with the AJAX request
        const response = await $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: {
                ...form.serializeArray().reduce((obj, item) => {
                    obj[item.name] = item.value;
                    return obj;
                }, {}),
                csrf_token: csrfToken
            }
        });

        if (response.success) {
            if (form.hasClass("login")) {
                form.trigger("login:success", response);
                authenticateCustomerEvents(response.userData, "Login Page", "user_login", true);
            }

            location.href = response.redirectUrl;
            return { error: false };
        } else {
            return { error: true };
        }
    } catch (error) {
        form.trigger("login:error", error);
        form.spinner().stop();
        return { error: true };
    }
};

/**
 * Handles the login process for a migrated customer by validating the password and processing the login attempt.
 * 
 * @param {Object} data - The data object containing customer information and bcrypt hash.
 * @param {jQuery} form - The jQuery form object containing the login form elements.
 * @param {number} failedAttempts - The number of failed login attempts.
 * 
 * @returns {Promise<number>} - A promise that resolves to the updated number of failed login attempts.
 */
const handleMigratedCustomer = async (data, form, failedAttempts) => {
    const password = form.find("input.password-field").val();
    const isPasswordMatch = bcrypt.compareSync(password, data.bcryptHash);
    let error = false;

    if (isPasswordMatch) {
        const completeMigrationResult = await completeMigration(form, data.continueUrl);
        if (completeMigrationResult.error) {
            error = true;
        }
    } else {
        error = true;
    }

    if (error) {
        if (form.hasClass("login")) {
            formValidation(form, data);
            form.trigger("login:error", data);
        }
        failedAttempts = processFailedAttempts(failedAttempts);
    }

    return failedAttempts;
};

module.exports = {
    processFailedAttempts,
    handleMigratedCustomer
};
